import React from "react";

export const Newbie = (props) => {
  return (
    <div id="newbie">
      <div className="container">
        <div className="col-md-12 text-center">
          <img src="img/title-newbie.png" className="img-title" alt="" />
        </div>
        <div className="row text-center">
          <div className="col-md-12">
            <div className="newbie">
              <img src="img/newbie/01.png" className="img-newbie" alt="" />
              <img src="img/newbie/02.png" className="img-newbie" alt="" />
              <img src="img/newbie/03.png" className="img-newbie" alt="" />
              <img src="img/newbie/04.png" className="img-newbie" alt="" />
            </div>
            <div>
              <a href="line://app/2007605903-BR0b43NW?_ads=Home_header_line">
                <img src="img/newbie-icon.png" className="icon-newbie" alt="" />
              </a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
